module.exports = __webpack_public_path__ + "static/media/55_000081.15ac33fc.jpg";